export const BOOKMARK_LIST_LIMIT = 10
